<template>
  <b-container class="p-0" fluid>
    <b-row class="p-3">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <h4>{{ title }}</h4>
      </div>

      <div class="col text-left">
        <div class="col-auto mx-auto">
          <b-row>
            <slot name="buttons"></slot>
          </b-row>
        </div>
      </div>
    </b-row>

    <b-row class="p-3">
      <slot name="filters"></slot>
    </b-row>

    <slot name="table"></slot>
  </b-container>
</template>
<script>
export default {
  name: "TableLayout",
  props: ["title"],
};
</script>